import React from 'react';
import { render } from 'react-dom';
import InfiniteCalendar from 'react-infinite-calendar';
import 'react-infinite-calendar/styles.css'; // only needs to be imported once

//Render the Calendar
let today = new Date();
let currentEndDate = new Date();
let lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());

class Calendar extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			minDate: lastMonth,
			shouldRefresh: false,
			display: null,
		};
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (nextProps.display != nextState.display) {
			this.setState({ display: nextProps.display })
		}
		return true;
	}

	handleSelect = (selectedDate) => {
		this.setState({
			shouldRefresh: true,
			display: null,
		})
		this.props.onSelect(selectedDate);
	}

	render() {
		let style = {
			position: 'relative',
		};

		style = Object.assign(style, this.props.style);

		let width = 0;
		let height = 0;
		let left = 0;

		if (window.innerWidth < 800) {
			width = 250;
			height = 250;
		} else {
			width = 400;
			height = 300;
		}

		if (this.props.width != null && this.props.width != undefined) width = this.props.width;
		if (this.props.height != null && this.props.height != undefined) height = this.props.height;
		if (this.props.left != null && this.props.left != undefined) left = this.props.left;

		return (
			<div style={style} >
				<div style={{ position: 'absolute', left: left, width: width }}>
					<InfiniteCalendar
						onSelect={(event) => this.handleSelect(event)}
						width={'100%'}
						height={height}
						selected={this.props.selected_date}
						display={this.state.display}
						displayOptions={this.props.displayOptions}
						maxDate={this.props.max_date}
					/>
				</div>
			</div>
		);
	}
}

export default Calendar;
